import { createEndpoint } from '@/shared/models/api';
import { ConverterRequest } from '@/app/api/morgan-thermal/converter';

export const convertSpeed = createEndpoint<number>(({fetch}) => ({ isMetric, value }: ConverterRequest) => fetch(`/Converter/Speed/${isMetric}/${value}`));